import { render } from "./AddType.vue?vue&type=template&id=5c42021a"
import script from "./AddType.vue?vue&type=script&lang=js"
export * from "./AddType.vue?vue&type=script&lang=js"

import exportComponent from "/root/workspace/Collection_EVMd/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__